import axios from 'axios';
import { configUrl } from '../config';


const axiosInstance = axios.create({
    baseURL: configUrl.AssessmentServer,
    headers: {
        providerId: configUrl.MediNeerProviderId,
        contentProviderIds: configUrl.MediNeerContentProviderIds,
    },
});

export default axiosInstance;
